/**
 * Created by mh on 2017/5/23.
 */
import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import AudioPlayer from '../media/AudioPlayer';

import DropzoneUploader from './DropzoneUploader';

// @observer
const Ingest = (props) => {
    const [stage, setStage] = useState(0);
    const [audioFile, setAudioFile] = useState(null);

    const { match, file } = props;

    const style = {
        height: 200,
        border: 'dashed 2px #999',
        borderRadius: 5,
        position: 'relative',
        cursor: 'pointer',
    };

    const uploaderProps = {
        style,
        max_file_size: 1024 * 1024 * 50,
        // TODO this needs to come from the api and should not be here
        s3_url: 'https://smps-deliver-media-us-west-1.s3.amazonaws.com/deliver-media-upload/3plus-gbm/',
        // TODO this needs to come from the api and should not be here
        server: '',
        accept: '',
    };

    const onDrop = (files) => {
        console.log('OnDrop Files:', files);
        setAudioFile(files[0]);
        setStage(1);
    };

    const onUploadFinish = (args) => {
        console.log('OnUploadFinish', args);
    };

    const onUploadProgress = (args) => {
        console.log('OnUploadProgress', args);
    };

    const onUploadError = (args) => {
        console.log('OnUploadERROR', args);
    };

    return (
        <section>
            <h1>
                <FormattedMessage id="Ingest.IngestMedia" defaultMessage="Ingest Media" />
            </h1>
            {stage === 0 ? (
                <DropzoneUploader
                    onFinish={onUploadFinish}
                    onError={onUploadError}
                    onProgress={onUploadProgress}
                    onDrop={onDrop}
                    {...uploaderProps}
                    {...file}>
                    <div className="center-content-items">
                        <div className="text-center">
                            <svg
                                width="100"
                                height="100"
                                className="octicon octicon-cloud-upload"
                                viewBox="0 0 16 16"
                                version="1.1"
                                aria-hidden="true">
                                <path
                                    d="M7 9H5l3-3 3 3H9v5H7V9zm5-4c0-.44-.91-3-4.5-3C5.08 2 3 3.92 3 6 1.02 6 0 7.52 0 9c0 1.53 1 3 3 3h3v-1.3H3c-1.62 0-1.7-1.42-1.7-1.7 0-.17.05-1.7 1.7-1.7h1.3V6c0-1.39 1.56-2.7 3.2-2.7 2.55 0 3.13 1.55 3.2 1.8v1.2H12c.81 0 2.7.22 2.7 2.2 0 2.09-2.25 2.2-2.7 2.2h-2V12h2c2.08 0 4-1.16 4-3.5C16 6.06 14.08 5 12 5z" />
                            </svg>
                            <p>Choose files to Upload</p>
                            <p>or drag and drop them here</p>
                        </div>
                    </div>
                </DropzoneUploader>) : null}
            {stage === 1 ? (
                <div>
                    <p>Read out and display data for ingest</p>
                    <AudioPlayer audioUrl={audioFile.preview} metadata={null} />
                </div>) : null}
        </section>
    );
};


Ingest.propTypes = {
    match: PropTypes.object.isRequired,
};

export default injectIntl(Ingest);
